import sortBy from 'lodash/sortBy'
import api from '@/api'
import { ENTITIES } from '../constants'

export const getters = {
  getSkillNameFromId() {
    return (skillId) => this.getEntityById(ENTITIES.SKILLS, skillId)?.name
  },

  sortSkillsByName() {
    return () => sortBy(this.getEntity(ENTITIES.SKILLS), (skill) => skill.name.toLowerCase())
  },
}

export const actions = {
  async fetchSkills() {
    this.skills = await api.fetchSkills()
  },
}
